import "../css/Home.css";

import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Blog from "../components/Blog";
import FeaturedProducts from "../components/FeaturedProducts";

export default function Home() {
  const [categories, setCategories] = useState([]);

  const getCategories = async () => {
    try {
      const categories = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/categories`,
      });
      setCategories(categories.data);
    } catch (err) {
      console.log(err.response.data.msg);
    }
  };

  useEffect(() => getCategories(), []);

  return (
    <div>
      <div className="hero_area">
        <div className="hero_bg_box">
          <img
            src={process.env.REACT_APP_IMG_BASE_URL + "header-woman-in-gym.jpg"}
            alt="woman-in-gym"
          />
        </div>
        <Navbar />

        <section className="slider_section ">
          <Carousel>
            {categories.map((category) => {
              return (
                <Carousel.Item key={category.id} interval={6000}>
                  <div className="detail-box">
                    <h1>{category.name}</h1>
                    <h3>Live well and better!</h3>
                    <Link to={`/categories/${category.slug}`}>View More</Link>
                  </div>
                </Carousel.Item>
              );
            })}
          </Carousel>
        </section>
      </div>

      <FeaturedProducts />

      <section className="about_section ">
        <div className="about_bg_box">
          <img
            src={process.env.REACT_APP_IMG_BASE_URL + "about-section-man-running.jpg"}
            alt="man-running"
          />
        </div>
        <div className="container ">
          <div className="row">
            <div className="col-md-6 ml-auto ">
              <div className="detail-box">
                <div className="heading_container">
                  <h2>
                    About this project
                  </h2>
                </div>
                <p className="mb-1">
                  On January 2022, we started our journey to become Full Stack developers. We
                  participated in Hack Academy's Coding Bootcamp, which was an intensive 3 months
                  long course where we learnt about Front and Back End development.
                </p>
                <p className="mt-0">
                  SuperPower is our final project, where we put everything we learnt in practice to
                  create a fully functional E-Commerce.
                </p>
                <p>To learn more about who we are and this project, click below.</p>
                <Link to="/about" className="mt_20">
                  READ MORE
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Blog />

      <Footer />
    </div>
  );
}
